import router from 'hyperdom/router.js'
import browserCapabilitiesImported from './browserCapabilities.js'
var browserCapabilities = (window.bookingServicesConfig && window.bookingServicesConfig.browserCapabilities) || browserCapabilitiesImported
import qs from 'qs'

export default browserCapabilities.historyApi
  ? router.router({querystring: qs})
  : router.router({querystring: qs, history: router.hash()})

export const redirect = function (rootPath) {
  if (!rootPath) {
    rootPath = '/'
  }

  if (!browserCapabilities.historyApi) {
    if (location.pathname != rootPath) {
      var path = location.pathname + location.search
      if (path.indexOf(rootPath) == 0) {
        path = path.substring(rootPath.length)
      } else if (path.indexOf('/') == 0) {
        path = path.substring(1)
      }
      location.href = rootPath + '#' + path
    }
  }
}
